import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    Center,
    Box,
    Text,
    VStack,
    HStack,
} from '@chakra-ui/react';
import { Button } from "@chakra-ui/react";
import Select from "react-select";
import LaporanPeserta from "../../components/LaporanPeserta";
import APIConfig from "../../api/APIConfig";
import ReactLoading from "react-loading";

const KegiatanAktif = () => {
    const [spinner, setSpinner] = useState(false)
    const [namaMitra, setNamaMitra] = useState();
    const [idLowonganPeserta, setIdLowonganPeserta] = useState()
    const [kegiatan, setKegiatan] =  useState();
    const [logoMitra, setLogoMitra] = useState();
    const [listLaporan, setListLaporan] = useState([]);
    const [selectedValue, setSelectedValue] = useState(0);
    const { id } = useParams();
    const navigate = useNavigate();

    const optionMonth = [
        { value: 1, label: "Januari" },
        { value: 2, label: "Februari" },
        { value: 3, label: "Maret" },
        { value: 4, label: "April" },
        { value: 5, label: "Mei" },
        { value: 6, label: "Juni" },
        { value: 7, label: "Juli" },
        { value: 8, label: "Agustus" },
        { value: 9, label: "September" },
        { value: 10, label: "Oktober" },
        { value: 11, label: "November" },
        { value: 12, label: "Desember" },
    ]

    useEffect(() => {
        getKegiatanLaporan();
    }, [])

    const handleSearchKategori = (e) => {
        setSelectedValue(e.value);
    };

    const matcher = (data) => {
        if (selectedValue === 0) return true;
        else if (selectedValue === 1) {
            if (data.bulan === 1) return true;
        } else if (selectedValue === 2) {
            if (data.bulan === 2)
            return true;
        } else if (selectedValue === 3) {
            if (data.bulan === 3) return true;
        } else if (selectedValue === 4) {
            if (data.bulan === 4) return true;
        } else if (selectedValue === 5) {
            if (data.bulan === 5) return true;
        } else if (selectedValue === 6) {
            if (data.bulan === 6) return true;
        } else if (selectedValue === 7) {
            if (data.bulan === 7) return true;
        } else if (selectedValue === 8) {
            if (data.bulan === 8) return true;
        } else if (selectedValue === 9) {
            if (data.bulan === 9) return true;
        } else if (selectedValue === 10) {
            if (data.bulan === 10) return true;
        } else if (selectedValue === 11) {
            if (data.bulan === 11) return true;
        } else if (selectedValue === 12) {
            if (data.bulan === 12) return true;
        }
        return false;
    };

    let data = listLaporan;
    data = data.filter((i) => matcher(i));
    console.log("test :" + data.length);

    const getKegiatanLaporan = async() => {
        setSpinner(true);
        // get kegiatan aktif
        const response = await APIConfig.get(`/v1/lowonganpeserta-aktif/${id}`);
        if (response.data==='') {setSpinner(false)};
        const result = await response.data;
        setIdLowonganPeserta(result.idLowonganPeserta);
        setLogoMitra(result.lowongan.mitra.image);
        setKegiatan(result.lowongan.proposal.namaPosisi);
        setNamaMitra(result.lowongan.mitra.namaBrand);

        // get list laporan
        const response2 = await APIConfig.get(`/v1/list-laporan/${result.idLowonganPeserta}`);
        const data = await response2.data
        setListLaporan(data);
        setSpinner(false)
    }

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <HStack py={6} pr={10}>
            <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                {idLowonganPeserta==null ? (
                <Box p={6}>
                <Text
                pt={5}
                pb={5}
                color={'gray.900'}
                fontWeight={500}
                fontSize={'2xl'}>
                Anda belum aktif pada lowongan manapun.
                </Text>
                <Button 
                onClick={() => navigate(`/peserta/kegiatanku/statuspendaftaran/${id}`)}
                fontSize='md' colorScheme='purple' variant='solid'>
                Lihat Status Pendaftaran
                </Button>
                </Box>
                ) : (
                <div>
                <HStack pt={10}>
                    <Box>
                        <img style={{width: '70px', height: '70px', objectFit: 'cover'}} src={logoMitra}/>
                    </Box>
                    <Box pl={5}>
                        <Text
                            color={'gray.700'}
                            fontWeight={600}
                            fontSize={'2xl'}>
                            {kegiatan}
                        </Text>
                        <Text
                            pt={2}
                            color={'gray.700'}
                            fontWeight={500}
                            fontSize={'xl'}>
                            {namaMitra}
                        </Text>
                    </Box>
                </HStack>
                <Box>
                    <Text
                        pt={7}
                        color={'gray.700'}
                        fontWeight={500}
                        fontSize={'l'}
                        justifyContent='left'>
                        Laporan Mingguan
                    </Text>
                </Box>
                <HStack pt={5} pr={12} justifyContent={"space-between"}>
                    <Select
                        borderRadius="50%"
                        fontSize='13px'
                        border='1px solid #F5F5F5'
                        height='100px' 
                        id='kategori' 
                        options={optionMonth}
                        onChange={handleSearchKategori}
                        value={optionMonth.find((obj) => obj.value === selectedValue)}
                        placeholder="-- Pilih Bulan --" />
                    <Button 
                        onClick={() => navigate(`/peserta/kegiatanku/kegiatanaktif/buatLaporan/${id}/${idLowonganPeserta}`)}
                        fontSize='md' colorScheme='purple' variant='solid'>
                        Buat Laporan Mingguan
                    </Button>
                </HStack>
                <Box pt={4} w='4xl' pr={12}>
                    {data.length > 0 ? 
                        <div>
                        {data.map((data) => (
                            <LaporanPeserta
                                idPeserta={data.idPeserta}
                                idLaporan={data.idLaporan}
                                waktuPost={data.waktuPost}
                                bulan={data.bulan}
                                minggu={data.minggu}
                                status={data.status}
                                kegiatan={data.namaKegiatan}
                                topik={data.topik}
                                laporan={data.isiLaporan}
                                feedback={data.feedback}
                            />
                    ))} 
                    </div> : <Text fontSize={"large"} fontWeight={'600'}>Belum ada laporan</Text>}
                </Box>
                </div>
                )}
            </VStack>
        </HStack>
    );
}

export default KegiatanAktif;